module.exports = __webpack_public_path__ + "static/media/giftcard-placeholder.2b425c12.png";